import type { LucideIcon } from 'lucide-react';

/** Haritada uçulabilen bir nokta */
export type MapPoint = {
  coords: [number, number];
  zoom: number;
  name: string;
};

/** Yakın çevre kartlarının veri şekli */
export type DistanceEntry = {
  icon: LucideIcon;
  name: string;
  description: string;
  distance: string;
  color: string;
  coords: [number, number];
  zoom: number;
  secondaryName?: string;
  secondaryDistance?: string;
  secondaryCoords?: [number, number];
  customMapIcon?: 'mosque';
};

export const MAIN_LOCATION: MapPoint = {
  coords: [40.924393, 29.16215],
  zoom: 16,
  name: 'Rain Nova',
};
